export function getPaginationPages(
  currentPage: number,
  pageCount: number,
): (number | 'ellipsis')[] {
  if (pageCount <= 0) return []
  if (pageCount === 1) return [1]

  const pages = new Set<number>()
  pages.add(1)
  pages.add(pageCount)
  for (
    let i = Math.max(1, currentPage - 1);
    i <= Math.min(pageCount, currentPage + 1);
    i++
  ) {
    pages.add(i)
  }

  const sorted = [...pages].sort((a, b) => a - b)
  const result: (number | 'ellipsis')[] = []
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push('ellipsis')
    }
    result.push(sorted[i])
  }
  return result
}
